module.exports = __webpack_public_path__ + "media/images/episode3-7ffec2eade57fda140b64d496f3630c2.jpeg";